import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from './../../../../../../core/toast.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { AddPriceUnitService } from '../../services/add-price-unit.service';

@Component({
  selector: 'app-add-price-unit',
  templateUrl: './add-price-unit.component.html',
  styleUrls: ['./add-price-unit.component.scss']
})
export class AddPriceUnitComponent implements OnInit {

  priceUnitForm = this.fb.group({
    name: [null, [Validators.required]]
  })

  constructor(
    private fb: FormBuilder,
    private addPriceUnitService: AddPriceUnitService,
    private toast: ToastService,
    private matDialogRef: MatDialogRef<AddPriceUnitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if(this.data && this.data.name){
      this.name.setValue(this.data.name);
    }
  }


  async addSupplyCategory(){
    if(this.priceUnitForm.invalid){
      this.toast.openSnackBar('Please enter valid name');
      this.priceUnitForm.markAllAsTouched();
      return;
    }
    const supplyCategory = this.priceUnitForm.value as any;
    try {
      const response = await this.addPriceUnitService.addPriceUnit(supplyCategory);
      this.toast.openSnackBar('Price unit added successfully');
      this.closeDialog(response);
    } catch(error){
      this.toast.openSnackBar('Unable to add price unit');
    }

  }

  closeDialog(status: any){
        document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.matDialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */

  get name(){
    return this.priceUnitForm.get('name')
  }
}

